import { DistributionChartSpec, UnitOptions } from '@/core';
import { OptionsEditorProps } from '@/plugin-system';

export const DEFAULT_UNIT: UnitOptions = { kind: 'Decimal', abbreviate: true };
export type DistributionChartOptionsEditorProps = OptionsEditorProps<DistributionChartSpec>;

/**
 * Creates the initial/empty options for a DistributionChart panel.
 */
export function createInitialDistributionChartSpec(): DistributionChartSpec {
  return {};
}
